





















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitPositionData } from '@/api/heritageUnit/unitBase'

@Component
export default class UnitPositionsView extends Vue {
  public name = 'UnitPositionsView'
  @Prop({ default: null })
  public dataList: UnitPositionData[] = []

  get filterSource(): any {
    let fs: any = []
    let types: number[] = []
    this.dataList.forEach((item: UnitPositionData, i: number) => {
      if (types.indexOf(item.PositionType) < 0) {
        fs.push({ text: item.TypeName, value: item.TypeName })
        types.push(item.PositionType)
      }
    })
    return fs
  }
  public filterMethod(value: string, row: UnitPositionData): boolean {
    return row.TypeName === value
  }

  public setData(data: UnitPositionData[]) {
    this.dataList = data
  }

  public expandKeys: number[] = []
  public expandClass(id: number): string {
    if (this.expandKeys.findIndex(v => v == id) > -1) {
      return 'el-icon-arrow-down'
    }
    else {
      return 'el-icon-arrow-right'
    }
  }
  public rowExpand(row: any, event: any, column: any) {
    var index = this.expandKeys.findIndex((v: any) => v == row.Id)
    if (index < 0) {
      //展开，查询子级
      this.expandKeys.push(row.Id)
    } else {
      // 移除展开项      
      this.expandKeys.splice(index, 1)
    }
  }
}
